export default "__VITE_ASSET__087a6240__"